var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "device-list" },
    [
      _vm._l(_vm.devices, function (device) {
        return _c("div", { key: device.id, staticClass: "device-item" }, [
          _c("div", { staticClass: "device-info" }, [
            _c("div", { staticClass: "content" }, [
              _c("h2", [_vm._v(_vm._s(device.device_name))]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v("Kategorie")]),
                _vm._v(_vm._s(device.device_type.name)),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v("Hersteller")]),
                _vm._v(
                  _vm._s(
                    device.device_brand.name
                      ? device.device_brand.name
                      : device.fallback.device_brand
                  ) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v("Modell")]),
                _vm._v(
                  _vm._s(
                    device.device_model.name
                      ? device.device_model.name
                      : device.fallback.device_model
                  ) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: device.device_model.url
                      ? device.device_model.url
                      : device.fallback.device_accessories_url,
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-lg btn-primary col-12 col-sm-12 col-md-6 col-lg-5 mx-auto mt-3",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "position-relative mr-1",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "#ffffff",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "11", cy: "11", r: "8" },
                          }),
                          _vm._v(" "),
                          _c("line", {
                            staticStyle: { top: "-3px" },
                            attrs: {
                              x1: "21",
                              y1: "21",
                              x2: "16.65",
                              y2: "16.65",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$translate(
                              "maversandVuePlugin::Additional.deviceSearchTriggerSearch"
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "device-actions" }, [
            _c(
              "button",
              {
                staticClass: "btn-edit",
                on: {
                  click: function ($event) {
                    return _vm.editDevice(device.device_id)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "#ffffff",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("polygon", {
                      attrs: { points: "16 3 21 8 8 21 3 21 3 16 16 3" },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-remove",
                on: {
                  click: function ($event) {
                    return _vm.removeDevice(device.device_id)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "#F20000",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("polyline", { attrs: { points: "3 6 5 6 21 6" } }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                      },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "10", y1: "11", x2: "10", y2: "17" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "14", y1: "11", x2: "14", y2: "17" },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "editModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "editModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title h3",
                      attrs: { id: "editModalLabel" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$translate(
                              "maversandVuePlugin::Additional.deviceManagerEditModalHead"
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "#000000",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("line", {
                            attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("device-edit-popup", {
                      attrs: {
                        disableSearch: true,
                        "initial-device-id": _vm.deviceId,
                        "user-id": _vm.$props.userId,
                      },
                      on: { "update-device": _vm.updateHandler },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "deleteModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "deleteModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-dialog-centered delete-modal",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content text-dark" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    staticStyle: { color: "#000000" },
                  },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title h3",
                        attrs: { id: "deleteModalLabel" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "maversandVuePlugin::Additional.deviceManagerDeleteModalHead"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "data-dismiss": "modal" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          },
                          [
                            _c("line", {
                              attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$translate(
                          "maversandVuePlugin::Additional.deviceManagerDeleteModalSub"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn delete btn-lg btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.confirmRemoveDevice },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$translate(
                              "maversandVuePlugin::Additional.deviceManagerDeleteModalButton"
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }